<template>
    <kb-container fluid class="top-padding bottom-padding no-horiz-padding">

        <h3 style="padding-top:0">Weaving Draft: {{draft.DisplayTitle}}, #{{draft.PatternID}}</h3>

        <subscriber-login-prompt/>

        <hr class="no-vertical-spacing" v-if="isSubscriber" />

        <div class="small-top-padding">
            <kb-button v-if="(!viewVisible) && isSubscriber" class='small-bottom-margin small-right-padded' size='sm' variant='secondary' @click='toggleViewButton'>View &raquo;</kb-button>
            <kb-button v-if="viewVisible && isSubscriber" class='small-bottom-margin small-right-padded' size='sm' variant='dark' @click='toggleViewButton'>View &darr;</kb-button>
            <kb-button v-if="!actionsVisible" class='small-bottom-margin small-right-padded' size='sm' variant='secondary' @click='toggleActionsButton'>Actions &raquo;</kb-button>
            <kb-button v-if="actionsVisible" class='small-bottom-margin small-right-padded border-dark' size='sm' variant='dark' @click='toggleActionsButton'>Actions &darr;</kb-button>
            <kb-button v-if="(!tagsVisible && ((this.allPatternTags.length > 0) || isAuthenticated))" class='small-bottom-margin small-right-padded' size='sm' variant='secondary' @click='toggleTagsButton'>{{tagsButtonTitle}} &raquo;</kb-button>
            <kb-button v-if="tagsVisible" class='small-bottom-margin small-right-padded border-dark' size='sm' variant='dark' @click='toggleTagsButton'>{{tagsButtonTitle}} &darr;</kb-button>
            <kb-button v-if="(!commentsVisible && ((this.allPatternComments.length > 0) || isAuthenticated))" class='small-bottom-margin small-right-padded' size='sm' variant='secondary' @click='toggleCommentsButton'>{{ commentsButtonTitle }} &raquo;</kb-button>
            <kb-button v-if="commentsVisible" class='small-bottom-margin small-right-padded border-dark' size='sm' variant='dark' @click='toggleCommentsButton'>{{ commentsButtonTitle }} &darr;</kb-button>

            <kb-button v-if="!toolsVisible && isAuthenticated && isSubscriber" class='small-bottom-margin small-right-padded' size='sm' variant='secondary' @click='toggleToolsButton'>Tools &raquo;</kb-button>
            <kb-button v-if="toolsVisible && isAuthenticated && isSubscriber" class='small-bottom-margin small-right-padded border-dark' size='sm' variant='dark' @click='toggleToolsButton'>Tools &darr;</kb-button>

            <share-button/>
            <kb-button v-if="isAuthenticated && (!isLiked)" class='small-bottom-margin small-right-padded' hideBorder=true size='sm' variant='outline-secondary' @click='toggleLikeButton'><span class="glyphicon glyphicon-thumbs-up"></span> Like</kb-button>
            <kb-button v-if="isAuthenticated && isLiked" class='small-bottom-margin small-right-padded' hideBorder=true size='sm' variant='outline-primary' @click='toggleLikeButton'><span class="glyphicon glyphicon-thumbs-up"></span> Like</kb-button>
        </div>
        <div>
            <div v-if="isSubscriber && viewVisible" class="inline-auto-width right-padding align-top">
                Tieup<br />
                <table>
                    <tr>
                        <td class="medium-right-padding"><input type='radio' v-model="orientation" name='orientation' value="tl"/></td>
                        <td class="medium-right-padding"><input type='radio' v-model="orientation" name='orientation' value="tr"/></td>
                    </tr>
                    <tr>
                        <td class="medium-right-padding"><input type='radio' v-model="orientation" name='orientation' value="bl"/></td>
                        <td class="medium-right-padding"><input type='radio' v-model="orientation" name='orientation' value="br"/></td>
                    </tr>
                </table>
            </div>
            <div v-if="isSubscriber && viewVisible" class="inline-auto-width right-padding align-top">
                View Size<br />
                <kb-form-select v-model="viewsize" :options='viewsizeOptions'/>
            </div>
            <div v-if="isSubscriber && viewVisible" class="inline-auto-width right-padding align-top">
                <br />
                <input v-if="straightThreadingOptionVisible" v-model="straightThreading" type="checkbox" /><span v-if="straightThreadingOptionVisible">&nbsp;Straight Threading</span><br v-if="straightThreadingOptionVisible" />
                <input v-if="straightTreadlingOptionVisible" v-model="straightTreadling" type="checkbox" /><span v-if="straightTreadlingOptionVisible">&nbsp;Straight Treadling</span><br v-if="straightTreadlingOptionVisible" />
                <input v-if="pointThreadingOptionVisible" v-model="pointThreading" type="checkbox" /><span v-if="pointThreadingOptionVisible">&nbsp;Point Threading</span><br v-if="pointThreadingOptionVisible" />
                <input v-if="pointTreadlingOptionVisible" v-model="pointTreadling" type="checkbox" /><span v-if="pointTreadlingOptionVisible">&nbsp;Point Treadling</span><br v-if="pointTreadlingOptionVisible" />
                <input v-model="turned" type="checkbox" />&nbsp;Turned<br />
                <input v-model="showAsLiftplan" type="checkbox" />&nbsp;Show&nbsp;Liftplan
            </div>

            <div v-if='!isSubscriber' class='small-top-padding'></div>

            <div v-if='actionsVisible' class="right-padding align-top small-top-padding">
                <div v-if='isSubscriber || isAuthenticated' class="inline-auto-width top-align small-right-padded">
                    <kb-button v-if="isSubscriber" class='small-bottom-margin' variant='outline-secondary' @click='showDownloadDialog'>Download WIF &raquo;</kb-button>
                </div>
                <div v-if='this.isAuthenticated' class="inline-auto-width small-bottom-margin top-align small-right-padded">
                    <kb-dropdown variant='outline-secondary' text="Add to Board" >
                        <kb-dropdown-item @click='addToBoard(clipboard)'>{{ clipboard.Title }}</kb-dropdown-item>
                        <kb-dropdown-divider v-if='draftBoards && draftBoards.length > 0'/>
                        <kb-dropdown-item v-for='board in draftBoards' :key='board.BoardID' @click='addToBoard(board)'>{{ board.Title }}</kb-dropdown-item>
                    </kb-dropdown>
                </div>
                <div class="inline-auto-width top-align">
                    <router-link :to='this.previousDraftDetailPageUrl' >
                        <kb-button variant='outline-secondary' class='small-bottom-margin small-right-padded' :to='this.previousDraftDetailPageUrl'>&laquo; Prev</kb-button>
                    </router-link>
                    <router-link :to='this.nextDraftDetailPageUrl' >
                        <kb-button variant='outline-secondary' class='small-bottom-margin small-right-padded' :to='this.nextDraftDetailPageUrl'>Next &raquo;</kb-button>
                    </router-link>
                </div>
                <div class="inline-auto-width top-align">
                    <kb-button variant='outline-secondary' class="small-bottom-margin small-right-padded" :to='this.collectionDraftPageUrl'>Collection &raquo;</kb-button>
                </div>
               <div v-if='matchingThreadingPatternsCount > 1' class="inline-auto-width top-align">
                    <kb-button variant='outline-secondary' class="small-bottom-margin small-right-padded" :to='threadingSearchPageUrl'>Same Threading ({{matchingThreadingPatternsCount}} {{(matchingThreadingPatternsCount > 1 ? 'drafts' : 'draft')}}) &raquo;</kb-button>
               </div>

               <div v-if='matchingTieupPatternsCount > 1' class="inline-auto-width top-align">
                    <kb-button variant='outline-secondary' class="small-bottom-margin small-right-padded" :to='tieupSearchPageUrl'>Same Tieup ({{matchingTieupPatternsCount}} {{(matchingTieupPatternsCount > 1 ? 'drafts' : 'draft')}}) &raquo;</kb-button>
               </div>

            </div>

            <div v-if='tagsVisible && isAuthenticated' style='margin-top: 0.5rem'>
                Add tags to help identify this draft.  Examples: satin, diamonds, hearts, braided twill...
                <kb-form-group class='inputBox'>
                    <div class='inline-auto-width' style='margin-right: 0.5rem'>
                        <vue3-simple-typeahead
                            id="typeahead_id"
                            placeholder="Enter a new tag for this draft..."
                            :items="partialMatchTagsList"
                            :minInputLength="1"
                            :itemProjection="tagNameProjectionFunction"
                            @onInput="debounceTagNameInput"
                            @selectItem="tagChosenFromList"
                        >
                        </vue3-simple-typeahead>
                    </div>
                    <div class='inline-auto-width'>
                        <kb-button size='sm' variant='primary' @click='addNewTag' @keydown.enter='addNewTag' type="button">Add Tag</kb-button>
                    </div>
                </kb-form-group>
                <div v-if='this.patternTags.length > 0' class='tags-list'>
                    <span class='bold-prompt'>Your tags for this draft</span> (click to remove):
                    <br/>
                    <kb-button :key='tag.PatternTagID' v-for='tag in patternTags' @click='removePatternTagConfirm(tag)' class='padded-button' size='sm' variant='default'><span class='glyphicon glyphicon-tag'/> {{tag.TagName}} &times;</kb-button>
                </div>

            </div>

            <div class='tags-list' v-if='tagsVisible && this.allPatternTags.length > 0'>
                <span class='bold-prompt'>Everyone's tags for this draft</span> (click to see all drafts for each):
                <br/>
                <kb-button :key='tag.PatternTagID' v-for='tag in allPatternTags' class='padded-button' :to='tagCollectionPageUrl(tag.TagID, tag.TagName)' size='sm' variant='default'><span class='glyphicon glyphicon-tag'/> {{tag.TagName}} &raquo;</kb-button>
            </div>

            <div v-if='commentsVisible'>
                <div class='comments-background-color' v-if='this.allPatternComments.length > 0'>
                    <div :key='comment.CommentID' v-for='comment in allPatternComments'>
                        <span class='bold-prompt'>{{ comment.OwnerName }}</span> &bull; <small> {{ comment.DateAddedStr }}&nbsp;&nbsp;{{ comment.TimeAddedStr }}</small><br/>
                        {{ comment.CommentText }}
                        <a v-if='isAuthenticated && authUser.UserID === comment.UserID' href='#' @click='removePatternCommentConfirm(comment)'><span class='glyphicon glyphicon-remove'/></a>
                        <hr style='padding-bottom:0; margin-bottom:0'/>
                    </div>
                </div>
                <div v-if='isAuthenticated'>
                    <kb-form-group size='sm' class='inputBox vertical-margins'>
                        <kb-form-textarea v-model='comment' placeholder='Enter a comment about this draft...' rows='2' max-rows='7' />
                    </kb-form-group>
                    <div style='margin-top: 1em'>
                        <kb-button size='sm' variant='primary' @click='addNewComment' type="button">Add Comment</kb-button>
                    </div>
                </div>
            </div>

            <div v-if='toolsVisible' class="right-padding align-top small-top-padding">
                <div v-if='draftEditingIsAvailable' class="inline-auto-width top-align">
                    <kb-button variant='outline-secondary' class="small-bottom-margin small-right-padded" @click='loadColorEditor'>Color Editor &raquo;</kb-button>
               </div>
                <div v-if='draftEditingIsAvailable' class="inline-auto-width top-align">
                    <kb-button variant='outline-secondary' class="small-bottom-margin small-right-padded" @click='loadDraftEditor'>Draft Editor &raquo;</kb-button>
               </div>
                <div v-if='profileDraftingIsAvailable' class="inline-auto-width top-align">
                    <kb-button variant='outline-secondary' class='small-bottom-margin small-right-padded' @click='loadProfileEditor'>Use Draft as Profile &raquo;</kb-button>
                </div>

                <div v-if='hasBlockProfile' class="inline-auto-width top-align">
                    <kb-button variant='outline-secondary' class='small-bottom-margin small-right-padded' @click='loadProfileEditorAsBlock'>Use Draft's Profile &raquo;</kb-button>
                </div>
                <div class="inline-auto-width top-align">
                    <kb-button variant='outline-secondary' class='small-bottom-margin small-right-padded' @click='loadDraftRepeatsEditor'>Draft Repeats &raquo;</kb-button>
                </div>
<!--
                <div v-if='useAsUnitWeaveAvailable' class="inline-auto-width top-align">
                    <kb-button variant='outline-secondary' class='small-bottom-margin top-align' @click='saveAsBlockWeave'>Use Draft's {{ draft.DDBlockUnitRows }} x {{ draft.DDBlockUnitCols }} Blocks &raquo;</kb-button>
                    <div v-if='unitWeaveA' class='inline-auto-width top-align'><drawdown-read-only :sampleDraft = 'unitWeaveA' :cellPixelSize = 'unitWeavesCellPixelSize' :showLines = 'true' :showReverse = 'false' renderingKey = 'a777' /></div>
                    <div v-if='unitWeaveB' class='inline-auto-width top-align'><drawdown-read-only :sampleDraft = 'unitWeaveB' :cellPixelSize = 'unitWeavesCellPixelSize' :showLines = 'true' :showReverse = 'false' renderingKey = 'a777' /></div>
                </div>

                <br v-if='unitWeaveAddedMessageVisible'/>
                <br v-if='unitWeaveAddedMessageVisible'/>
                <div class='top-align' v-if='unitWeaveAddedMessageVisible'>
                    This draft's {{ draft.DDBlockUnitRows }} x {{ draft.DDBlockUnitCols }} block weaves have been added to the beginning of the profile block weaves list for this session only.
                </div>
-->
                <div v-if="(amalgamationDraftingIsAvailable)" class="inline-auto-width top-align">
                    <kb-button v-if="(amalgamationDraftingIsAvailable)" class='small-bottom-margin small-right-padded' @click='loadAmalgamationEditor' variant='outline-secondary'>Amalgamation &raquo;</kb-button>
                </div>

                <div class="inline-auto-width top-align">
                    <kb-button variant='outline-secondary' class='small-bottom-margin small-right-padded' @click='loadDraftArranger'>Draft Arranger &raquo;</kb-button>
                </div>

                <br v-if='!draftEditingIsAvailable || !profileDraftingIsAvailable || !amalgamationDraftingIsAvailable'/>

                <div v-if='(!draftEditingIsAvailable && (!hasBlockProfile))' class='inline-auto-width top-align small-right-padded'>
                    This draft is too large for color or draft editing here.
                </div>

                <div v-if='(!profileDraftingIsAvailable && (!hasBlockProfile))' class='inline-auto-width top-align small-right-padded'>
                    This draft is too large to use as a profile draft here.
                </div>

                <div v-if='(!amalgamationDraftingIsAvailable && (!hasBlockProfile))' class='inline-auto-width top-align small-right-padded'>
                    Amalgamation is not available for this draft.
                </div>

            </div>

        </div>

        <div class="vertical-padding">
            <img v-if='!isMobileDevice && currentDraftImageUrl.length > 0' class="right-padding" :src="currentDraftImageUrl" :alt="'draft image:' + draft.Tooltip" />
            <!--
                fixes a bug on mobile webkit browsers where a large image actually increases the window size beyond the screen width to support horizontal scrolling,
                causing the Bootstrap have bar hamburger to push out to beyond the right side of the display, becoming invisible without scrolling
             -->
            <img v-if='isMobileDevice && currentDraftImageUrl.length > 0' style='max-width: 100%' class="right-padding" :src="currentDraftImageUrl" :alt="'draft image:' + draft.Tooltip" />
        </div>

        <div>
            <div class="small-top-padding right-padding" style="display: inline-block;">
                <table style="width: auto" class='draft-details-table'>
                    <tr>
                        <td class='greylabel' style="text-align: center">{{draft.Shafts}} Shafts, {{draft.Treadles}} Treadles</td>
                        <td style="text-align: center">Single Pattern Unit</td>
                        <td style="text-align: center">Repeats Shown</td>
                    </tr>
                    <tr>
                        <td style="text-align: right">Threading</td>
                        <td class='greylabel' style="text-align: center">{{draft.WarpUnitThreads}}</td>
                        <td class='greylabel' style="text-align: center">{{draft.WarpRepeatsShown}}</td>
                    </tr>
                    <tr>
                        <td style="text-align: right">Treadling</td>
                        <td class='greylabel' style="text-align: center">{{draft.WeftUnitThreads}}</td>
                        <td class='greylabel' style="text-align: center">{{draft.WeftRepeatsShown}}</td>
                    </tr>
                </table>
            </div>

            <div class="small-top-padding" style="display: inline-block;">

                <table style="width: auto" class="draft-details-table">
                    <tr>
                        <td style="text-align: center">Maximum Floats</td>
                        <td style="text-align: center">Front</td>
                        <td style="text-align: center">Back</td>
                    </tr>
                    <tr>
                        <td style="text-align: right">Warp</td>
                        <td class='greylabel' style="text-align: center">{{draft.MaxFrontWarpFloat}}</td>
                        <td class='greylabel' style="text-align: center">{{draft.MaxBackWarpFloat}}</td>
                    </tr>
                    <tr>
                        <td style="text-align: right">Weft</td>
                        <td class='greylabel' style="text-align: center">{{draft.MaxFrontWeftFloat}}</td>
                        <td class='greylabel' style="text-align: center">{{draft.MaxBackWeftFloat}}</td>
                    </tr>
                </table>
            </div>

            <div v-if='matchingThreadingPatternsCount <= 1'>
                <span>&nbsp;&nbsp;(no other drafts share this threading)</span>
            </div >
            <div v-if='matchingTieupPatternsCount <= 1'>
                <span>&nbsp;&nbsp;(no other drafts share this tieup)</span>
            </div >
        </div>

        <div class="top-padding">
            Provided By: {{draft.ContributedByName}}
        </div>

        <div v-if="draft.Notes && draft.Notes.length > 0" class="top-padding">
            Notes:<br/><br/>
            <div v-html="draft.Notes"/>
        </div>

        <h3 class='top-padding'>Source Collection</h3>

        <div>

            <router-link :to='this.collectionDraftPageUrl' :title='this.collection.TitleWithAuthors'>
                <img align='left' class='cover-image bottom-padding right-padding' :src='this.collectionCoverImageUrl' :alt='"Collection Cover Image Image for:" + this.collection.TitleWithAuthors'/>
            </router-link>

            <router-link :to='this.collectionDraftPageUrl' :title='this.collection.TitleWithAuthors'>
                <h3 style='display: inline' class="no-top-spacing">{{this.collection.TitleWithAuthors}}</h3>
            </router-link>

            <p v-if="collection.Description">
                <span v-html='collection.Description'/>
                <br />
            </p>

            <p v-if="this.collection.OriginalSourceLinkUrl">
                <a target='_blank' :href='collection.OriginalSourceLinkUrl'>{{collection.OriginalSourceLinkText}}</a>
                <br />
            </p>

            <p>
                <kb-button variant='primary' :to='this.collectionDraftPageUrl'>Browse Collection, {{collection.TotalPatterns}} Drafts &raquo;</kb-button>
            </p>
        </div>

        <div style='clear: both'>
            <related-store-products :collectionId = 'draft.BookID'></related-store-products>
        </div>

        <help-us-button/>
        <mail-chimp-signup/>

        <kb-modal auto-focus-button='cancel' ref='boardAddedModalRef' title='Draft Added to Board' ok-title='View Draft Board »' @ok='handleGoToBoard' cancel-title='Not Now' @cancel='handleBoardContinue' :no-close-on-backdrop='true' :no-close-on-esc='true'>
            <div class="d-block text-center">
                This draft was added to your {{ addedToBoardPrompt }}.  Would you like to view this now?
            </div>
        </kb-modal>

        <kb-modal ref='downloadModalRef' title='Choose WIF Type for Download' :ok-only='true' ok-title='Cancel' :no-close-on-backdrop='true' :no-close-on-esc='true' @ok='showDownloadDialog(false)'>
            <div class="d-block text-center">
                Would you like a standard or liftplan-only WIF? Choose standard if unsure.
                <br/>
                <br/>
                <kb-button class='small-right-margin' @click='downloadWIF(false)' variant='primary'>Download Standard WIF »</kb-button>
                <kb-button class='small-left-margin' @click='downloadWIF(true)' variant='primary'>Download Liftplan WIF »</kb-button>
            </div>
        </kb-modal>

        <kb-modal auto-focus-button='cancel' ref='removeTagConfirmModalRef' title='Remove Tag?' ok-title='Remove »' @ok='handleRemoveTag' cancel-title='Cancel' @cancel='handleRemoveTagCancel' :no-close-on-backdrop='true' :no-close-on-esc='true'>
            <div class="d-block text-center">
                Would you like to remove your tag &quot;{{tagToRemove.TagName}}&quot; from this draft?
            </div>
        </kb-modal>
        <kb-modal auto-focus-button='cancel' ref='removeCommentConfirmModalRef' title='Remove Comment?' ok-title='Remove »' @ok='handleRemoveComment' cancel-title='Cancel' @cancel='handleRemoveCommentCancel' :no-close-on-backdrop='true' :no-close-on-esc='true'>
            <div class="d-block text-center">
                Would you like to remove your comment &quot;{{commentToRemove.CommentText.substr(0, 25) + '...'}}&quot; from this draft?
            </div>
        </kb-modal>

    </kb-container>
</template>

<script>
import dataService from '../mixins/dataService.js'
import mediaService from '../mixins/mediaService.js'
import urlsService from '../mixins/urlsService.js'
import draftToolsState from '../mixins/draftToolsState.js'
import helpUsButton from './HelpUsButton.vue'
import mailChimpSignup from './MailChimpSignup.vue'
import relatedStoreProducts from './RelatedStoreProducts.vue'
import subscriberLoginPrompt from './SubscriberLoginPrompt.vue'
import utilityService from '../mixins/utilityService.js'
import draftToolsSuitability from '../mixins/draftToolsSuitability.js'
import cfg from '../config/config.js'
import shareButton from './ShareButton.vue'

let determineOptimalDraftDisplaySizeFunction

let MAX_RETHREAD_COUNT = 64

const emptyDraft = {
    PatternID: 0,
    BookID: 0,
    BookTitleWithAuthors: '',
    PatternTitle: '',
    Tooltip: '',
    DisplayTitle: '',
    CommonNames: '',
    Shafts: 0,
    Treadles: 0,
    WarpThreads: 0,
    WeftThreads: 0,
    EnteredByUserID: 0,
    ApprovedByUserID: 0,
    ApprovalDate: '0001-01-01T00:00:00',
    OriginalSource: '',
    AreaOfOrigin: '',
    TimePeriod: '',
    DateEntered: '0001-01-01T00:00:00',
    Notes: '',
    OriginalFilename: '',
    IsActive: true,
    WIFData: '',
    PrivateNotes: '',
    ContributorSerial: '',
    WarpUnitThreads: 0,
    WeftUnitThreads: 0,
    MaxFrontWarpFloat: 0,
    MaxFrontWeftFloat: 0,
    MaxBackWarpFloat: 0,
    MaxBackWeftFloat: 0,
    WarpRepeatsShown: 0,
    WeftRepeatsShown: 0,
    ImagesExist: true,
    ContributedByName: '',
    ProfileShafts: 1,
    ProfileTreadles: 1,
    DDBlockUnitRows: 1,
    DDBlockUnitCols: 1
}

const emptyCollection = {
    BookID: 0,
    Title: '',
    IsActive: true,
    Description: '',
    Authors: '',
    TitleWithAuthors: '',
    PublicationDate: '',
    ISBN: '',
    LC: '',
    CoverPhotoName: '',
    PublisherName: '',
    TotalPatterns: 0,
    IndexItemCount: 0,
    OriginalSourceLinkUrl: '',
    OriginalSourceLinkText: ''
}

export default {
    mixins: [dataService, mediaService, urlsService, utilityService, draftToolsSuitability, draftToolsState],
    data: function() {
        return {
            orientation: 'tl',
            viewsize: 4,
            straightThreading: false,
            straightTreadling: false,
            pointThreading: false,
            pointTreadling: false,
            turned: false,
            showAsLiftplan: false,
            draft: emptyDraft,
            previousDraft: emptyDraft,
            nextDraft: emptyDraft,
            collection: emptyCollection,
            collectionPageNumber: 0,
            previousDraftDetailPageUrl: '',
            nextDraftDetailPageUrl: '',
            collectionDraftPageUrl: '',
            collectionFirstPageUrl: '',
            collectionCoverImageUrl: '',
            threadingSearchPageUrl: '',
            draftHasPointCompatibleThreading: false,
            draftHasPointCompatibleTreadling: false,
            viewsizeOptions: [
                { value: 2, text: 'smallest' },
                { value: 3, text: 'smaller' },
                { value: 4, text: 'small' },
                { value: 5, text: 'medium' },
                { value: 7, text: 'large' },
                { value: 9, text: 'larger' },
                { value: 11, text: 'largest' }
            ],
            windowWidth: 0,
            windowHeight: 0,
            matchingThreadingPatternsCount: 0,
            matchingTieupPatternsCount: 0,
            viewVisible: false,
            actionsVisible: false,
            toolsVisible: false,
            tagsVisible: false,
            commentsVisible: false,
            viewButtonPrompt: 'Download WIF &raquo;',
            tagNameToAdd: '',
            partialMatchTagsList: [],
            patternTags: [],
            allPatternTags: [],
            allPatternComments: [],
            comment: '',
            tagToRemove: { TagID: 0, TagName: 'placeholder' },
            commentToRemove: { CommentID: 0, CommentText: 'placeholder' },
            isLiked: false,
            draftBoards: [],
            clipboard: { BoardID: 0, Title: 'Clipboard', OwnerName: '' },
            addedToBoard: {},
            addedToBoardPrompt: '',
            unitWeavesForPattern: null,
            unitWeaveA: null,
            unitWeaveB: null,
            unitWeaveAddedMessageVisible: false
        }
    },
    components: {
        helpUsButton: helpUsButton,
        mailChimpSignup: mailChimpSignup,
        relatedStoreProducts: relatedStoreProducts,
        subscriberLoginPrompt: subscriberLoginPrompt,
        shareButton: shareButton
    },
    methods: {

        debounceTagNameInput(eventObj) {
            if (eventObj && eventObj.input) {
                // works around a bug in vue3-simple-typeahead where the model is not updated
                this.tagNameToAdd = eventObj.input
            }
            this.debounceInput(function() {
                // console.log('in debounceTagNameInput, eventObj: ' + JSON.stringify(eventObj))
                this.loadMatchingTagsByPartialName(eventObj.input)
            }, 250)
        },

        tagNameProjectionFunction(t) {
            return t.TagName
        },

        tagChosenFromList(tag) {
            // console.log('tag chosen: ' + JSON.stringify(tag))
            this.tagNameToAdd = tag.TagName
        },

        loadMatchingTagsByPartialName(partialName) {
            // console.log('in loadMatchingTagsByPartialName, partialName: ' + partialName)
            let userID = 0 // auto suggest using tags from everyone
            if (partialName.length > 1) {
                this.getTagsByPartialName(userID, partialName).then(resp => {
                    // console.log('returned tags list: ' + JSON.stringify(resp.data))
                    this.partialMatchTagsList = this.sortPartialTags(partialName, resp.data)
                })
            }
            else {
                this.partialMatchTagsList = []
            }
        },

        sortPartialTags(searchTerm, tagsList) {
            // sort tags alphabetically, then move the ones starting with numbers to the bottom of the list
            tagsList.sort(this.tagsComparer)
            let startsWithSearchTermTags = []
            let alphaTags = []
            let numericTags = []
            for (let c=0; c < tagsList.length; c++) {
                let tag = tagsList[c]
                if (this.tagStartsWithSearchTerm(searchTerm, tag)) {
                    startsWithSearchTermTags.push(tag)
                }
                else if (this.tagStartsWithNumber(tag)) {
                    numericTags.push(tag)
                }
                else {
                    alphaTags.push(tag)
                }
            }
            return startsWithSearchTermTags.concat(alphaTags.concat(numericTags))
        },

        tagsComparer(tag1, tag2) {
            return tag1.TagName.toLowerCase() > tag2.TagName.toLowerCase()
        },

        tagStartsWithNumber(tag) {
            return !isNaN(tag.TagName.charAt(0))
        },

        tagStartsWithSearchTerm(term, tag) {
            return tag.TagName.toLowerCase().startsWith(term.toLowerCase())
        },

        tagCollectionPageUrl: function(tagId, tagName) {
            return this.buildMatchingTagsCollectionUrl(tagId, tagName, 'alltags')
        },

        showDownloadDialog(isVisible) {
            isVisible? this.$refs.downloadModalRef.show() : this.$refs.downloadModalRef.hide()
        },

        downloadWIF: function(isLiftplan) {
            this.showDownloadDialog(false)
            this.postAnalytics(this.authUser.UserID, 0, this.draft.PatternID, true).then(resp => {
                let wifDownloadUrl = ''
                if (!this.turned) {
                    wifDownloadUrl = this.getWIFDownloadUrl(this.authUser.UserID, this.authUser.LoginToken, this.draft.PatternID, this.turned, this.straightThreading, this.straightTreadling, this.pointThreading, this.pointTreadling, isLiftplan)
                }
                else {
                    wifDownloadUrl = this.getWIFDownloadUrl(this.authUser.UserID, this.authUser.LoginToken, this.draft.PatternID, this.turned, this.straightTreadling, this.straightThreading, this.pointTreadling, this.pointThreading, isLiftplan)
                }
                window.location.assign(wifDownloadUrl)
            })
        },

        determineOptimalDraftDisplaySize: function() {
            // work around Webkit bug where mobile scrolling sometimes triggers resize event even though window is not resizing
            if (window.innerWidth !== this.windowWidth) {
                this.viewsize = this.calculateDraftInitialDisplaySize(this.draft, window.innerWidth, false)
                this.windowWidth = window.innerWidth
                this.windowHeight = window.innerHeight
            }
        },

        addToBoard(board) {
            if (this.isAuthenticated) {
                this.addedToBoard = board
                if (board.BoardID===0) {
                    this.addedToBoardPrompt = 'draft clipboard'
                    this.postClipboardPattern(this.authUser.UserID, this.draft.PatternID, this.authUser.LoginToken).then(resp => {
                        this.showAddedToBoardDialog(true)
                    })
                }
                else {
                    this.addedToBoardPrompt = 'board: ' + board.Title
                    this.addUserBoardPattern(board.BoardID, this.draft.PatternID, this.authUser.UserID, this.authUser.LoginToken).then(resp => {
                        this.showAddedToBoardDialog(true)
                    })
                }
            }
        },

        showAddedToBoardDialog(isShow) {
            isShow ? this.$refs.boardAddedModalRef.show() : this.$refs.boardAddedModalRef.hide()
        },

        handleGoToBoard() {
            if (this.addedToBoard.BoardID === 0) {
                this.$router.push({ name: 'DraftSearch', params: { searchType: 'clipboard' } })
            }
            else {
                let sanitizedTitle = this.sanitizeUrlSegment(this.addedToBoard.Title)
                this.$router.push({ name: 'DraftSearch', params: { searchType: 'board', bookOrCategoryId: this.addedToBoard.BoardID, collectionTitle: sanitizedTitle } })
            }
        },

        handleBoardContinue() {
            this.showAddedToBoardDialog(false)
        },

        flipThreadingOptionsUponTurned() {
            if (this.straightThreading !== this.straightTreadling) {
                let formerStraightThreading = this.straightThreading
                this.straightThreading = this.straightTreadling
                this.straightTreadling = formerStraightThreading
            }
            if (this.pointThreading !== this.pointTreadling) {
                let formerPointThreading = this.pointThreading
                this.pointThreading = this.pointTreadling
                this.pointTreadling = formerPointThreading
            }
        },

        loadDraftData() {
            let draftId = this.$route.params.id
            if (draftId) { // goes null if user signs out
                this.getPattern(draftId).then(resp => {
                    this.draft = resp.data
                    this.draft.Notes = this.draft.Notes.split('\\n').join('<br />')
                    this.$store.commit('setPageTitle', 'Weaving Draft ' + this.draft.DisplayTitle + ', #' + this.draft.PatternID)
                    this.draftHasPointCompatibleThreading = (this.draft.PointedShafts > 0)
                    this.draftHasPointCompatibleTreadling = (this.draft.PointedTreadles > 0)

                    // if (this.hasBlockProfile()) {
                    //     // console.log('has block profile!')
                    // }
                    // else {
                    //     // console.log('no block profile')
                    // }

                    // drafts for collection prev and next come in without titles to avoid having to query the entire drafts
                    // on the detail page, so add in the title here once we know it by loading the draft for display
                    // this saves two network calls on every draft display
                    if (!this.$route.params.title) {
                        this.addDisplayTitleToUrl(this.draft)
                    }

                    this.getCollection(this.draft.BookID).then(resp => {
                        this.collection = resp.data
                        this.determineOptimalDraftDisplaySize()
                        this.getPatternCollectionPositionFiltered(draftId, this.collection.BookID, this.authUserSettings.MinShafts, this.authUserSettings.MaxShafts, this.authUserSettings.MaxTreadles, this.authUserSettings.MaxFloatLength).then(resp => {
                            // console.log('getPatternCollectionPositionFiltered: ' + JSON.stringify(resp))
                            if (resp.data.CollectionPosition > 0) {
                                // pattern is included in user's filter criteria, use previous, next, and collection position data from that
                                this.loadPreviousNextInfo(draftId, resp)
                            }
                            else { // pattern was excluded by user's filter criteria but loaded individually, clear filters and try again
                                this.clearAllFiltersUserSettings()
                                this.getPatternCollectionPositionFiltered(draftId, this.collection.BookID, this.authUserSettings.MinShafts, this.authUserSettings.MaxShafts, this.authUserSettings.MaxTreadles, this.authUserSettings.MaxFloatLength).then(resp => {
                                    // console.log('getPatternCollectionPositionFiltered after clearing filters: ' + JSON.stringify(resp))
                                    this.loadPreviousNextInfo(draftId, resp)
                                })
                            }
                        })
                    })
                    this.loadTagsForPattern()
                    this.loadCommentsForPattern()
                    if (this.isAuthenticated) {
                        this.loadPatternLikes()
                        this.loadUserBoards()
                    }
                })
            }
        },

        loadPreviousNextInfo(draftId, resp) {
            let nextDraftId = resp.data.NextPatternID
            let previousDraftId = resp.data.PreviousPatternID
            let collectionPosition = resp.data.CollectionPosition - 1 // sql is 1 based for rownumber, 0 is easier here

            this.collectionPageNumber = Math.floor(collectionPosition / cfg.config.draftResultsPerPage)
            this.collectionDraftPageUrl = this.buildCollectionPageUrl(this.collection, this.collectionPageNumber)
            this.collectionFirstPageUrl = this.buildCollectionPageUrl(this.collection, 0)
            this.collectionCoverImageUrl = this.getCollectionCoverImageUrl(this.collection)

            this.previousDraftDetailPageUrl = this.buildDraftDetailUrl({ PatternID: previousDraftId, DisplayTitle: null })
            this.nextDraftDetailPageUrl = this.buildDraftDetailUrl({ PatternID: nextDraftId, DisplayTitle: null })

            determineOptimalDraftDisplaySizeFunction = this.determineOptimalDraftDisplaySize.bind(this)
            window.addEventListener('resize', determineOptimalDraftDisplaySizeFunction)

            this.postAnalytics(this.authUser.UserID, 0, draftId, false)
            this.loadMatchingThreadingPatternsCount()
            this.loadMatchingTieupPatternsCount()
        },

        clearAllFiltersUserSettings() {
            if (this.isAuthenticated) {
                let userSettings = this.$store.state.authUserSettings
                // console.log('in clearAllFiltersUserSettings')
                userSettings.MinShafts = 0
                userSettings.MaxShafts = 0
                userSettings.MaxTreadles = 0
                userSettings.MaxFloatLength = 0
                this.$store.commit('setFilters', userSettings)
                // console.log('user settings after clear: ' + JSON.stringify(userSettings))
                this.putUserSettings(this.authUser.UserID, userSettings, this.authUser.LoginToken)
            }
        },

        loadMatchingThreadingPatternsCount() {
            if (this.draft.PatternID > 0) {
                return this.getMatchingThreadingPatternsCount(this.draft.PatternID, 0, this.turned, this.straightThreading, this.pointThreading, false).then(resp => {
                    this.matchingThreadingPatternsCount = resp.data
                    this.threadingSearchPageUrl = this.buildMatchingThreadingsCollectionUrl(this.draft.PatternID, 0, this.turned, this.straightThreading, this.pointThreading, 0, 0)
                })
            }
            else {
                this.matchingThreadingPatternsCount = 0
                this.threadingSearchPageUrl = ''
            }
        },

        loadMatchingTieupPatternsCount() {
            let threadingVariantName = 'n' // native
            if (this.straightThreading) {
                threadingVariantName = 's' // straight
            }
            if (this.pointThreading) {
                threadingVariantName = 'p' // point
            }
            let treadlingVariantName = 'n' // native
            if (this.straightTreadling) {
                treadlingVariantName = 's' // straight
            }
            if (this.pointTreadling) {
                treadlingVariantName = 'p' // point
            }

            // console.log('straightThreading: ' + this.straightThreading)
            // console.log('straightTreadling: ' + this.straightThreading)
            // console.log('pointThreading: ' + this.pointThreading)
            // console.log('pointTreadling: ' + this.pointThreading)
            // console.log('threading variant name:' + threadingVariantName)
            // console.log('treadling variant name:' + treadlingVariantName)

            if (this.draft.PatternID > 0) {
                return this.getMatchingTieupPatternsCount(this.draft.PatternID, 0, threadingVariantName, treadlingVariantName, this.turned, 0, 0).then(resp => {
                    this.matchingTieupPatternsCount = resp.data
                    this.tieupSearchPageUrl = this.buildMatchingTieupsCollectionUrl(this.draft.PatternID, 0, threadingVariantName, treadlingVariantName, this.turned)
                })
            }
            else {
                this.matchingTieupPatternsCount = 0
                this.tieupSearchPageUrl = ''
            }
        },

        loadTagsForPattern() {
            // console.log('in load tags for pattern 1')
            this.getPatternTags(this.draft.PatternID, 0).then(resp => {
                // console.log('in load all tags for pattern 2')
                this.allPatternTags = resp.data
                // console.log('loaded allPatternTags = ' + JSON.stringify(this.allPatternTags))
                if (this.isAuthenticated) {
                    this.getPatternTags(this.draft.PatternID, this.authUser.UserID).then(resp => {
                        // console.log('in load tags for pattern 3')
                        this.patternTags = resp.data
                        // console.log('loaded patternTags = ' + JSON.stringify(this.allPatternTags))
                    })
                }
            })
        },

        loadCommentsForPattern() {
            // console.log('in load comments for pattern 1')
            this.getPatternComments(this.draft.PatternID).then(resp => {
                // console.log('in load all comments for pattern 2')
                this.allPatternComments = resp.data
            })
        },

        loadPatternLikes() {
            this.getPatternLikes(this.draft.PatternID, this.authUser.UserID).then(resp => {
                let likesArray = resp.data
                this.isLiked = (likesArray && likesArray.length > 0)
            })
        },

        loadUserBoards() {
            this.getUserBoards(this.authUser.UserID).then(resp => {
                this.draftBoards = resp.data
            })
        },

        toggleViewButton() {
            let newValue = !this.viewVisible
            this.hideAllPanes()
            this.viewVisible = newValue
        },

        toggleActionsButton() {
            let newValue = !this.actionsVisible
            this.hideAllPanes()
            this.actionsVisible = newValue
        },

        toggleToolsButton() {
            let newValue = !this.toolsVisible
            this.hideAllPanes()
            this.toolsVisible = newValue
        },

        toggleTagsButton() {
            let newValue = !this.tagsVisible
            this.hideAllPanes()
            this.tagsVisible = newValue
        },

        toggleCommentsButton() {
            let newValue = !this.commentsVisible
            this.hideAllPanes()
            this.commentsVisible = newValue
        },

        loadUnitWeavesForPattern() {
            // console.log('getting unit weaves from pattern')
            let draftId = this.$route.params.id
            this.getPatternUnitWeavesJson(draftId, this.authUser.UserID, this.authUser.LoginToken).then(resp => {
                // console.log('Unit Weave: ' + JSON.stringify(resp.data))
                this.unitWeavesForPattern = resp.data
                this.unitWeaveA = JSON.parse(this.unitWeavesForPattern.UnitAJSON)
                this.unitWeaveB = JSON.parse(this.unitWeavesForPattern.UnitBJSON)
            })
        },

        toggleLikeButton() {
            // console.log('in toggleLikeButton, currently visible = ' + this.tagsVisible)
            this.isLiked = !this.isLiked
            if (this.isLiked) {
                // console.log('about to add like')
                this.addPatternLike(this.draft.PatternID, this.authUser.UserID, this.authUser.LoginToken)
            }
            else {
                // console.log('about to remove like')
                this.removePatternLike(this.draft.PatternID, this.authUser.UserID, this.authUser.LoginToken)
            }
        },

        hideAllPanes() {
            this.viewVisible = false
            this.actionsVisible = false
            this.toolsVisible = false
            this.tagsVisible = false
            this.commentsVisible = false
        },

        addNewTag() {
            // console.log('in addNewTag')
            this.addPatternTag(this.draft.PatternID, this.tagNameToAdd, this.authUser.UserID, this.authUser.LoginToken).then(resp => {
                this.loadTagsForPattern()
                this.tagNameToAdd = ''
            })
        },

        addNewComment() {
            // console.log('in addNewTag')
            this.addPatternComment(this.draft.PatternID, this.comment, this.authUser.UserID, this.authUser.LoginToken).then(resp => {
                this.loadCommentsForPattern()
                this.comment = ''
            })
        },

        removePatternTagConfirm(tag) {
            // console.log('in removePatternTagConfirm, tag: ' + JSON.stringify(tag))
            this.tagToRemove = tag
            this.showRemoveTagDialog(true)
        },

        removePatternCommentConfirm(comment) {
            // console.log('in removePatternCommentConfirm, comment: ' + JSON.stringify(comment))
            this.commentToRemove = comment
            this.showRemoveCommentDialog(true)
        },

        showRemoveCommentDialog(isShow) {
            isShow ? this.$refs.removeCommentConfirmModalRef.show() : this.$refs.removeCommentConfirmModalRef.hide()
        },

        showRemoveTagDialog(isShow) {
            isShow ? this.$refs.removeTagConfirmModalRef.show() : this.$refs.removeTagConfirmModalRef.hide()
        },

        handleRemoveTag() {
            this.removePatternTag(this.draft.PatternID, this.tagToRemove.TagID, this.authUser.UserID, this.authUser.LoginToken).then(resp => {
                this.loadTagsForPattern()
                this.showRemoveTagDialog(false)
            })
        },

        handleRemoveTagCancel() {
            this.showRemoveTagDialog(false)
        },

        handleRemoveComment() {
            this.removePatternComment(this.commentToRemove.CommentID, this.authUser.UserID, this.authUser.LoginToken).then(resp => {
                this.loadCommentsForPattern()
                this.showRemoveCommentDialog(false)
            })
        },

        handleRemoveCommentCancel() {
            this.showRemoveCommentDialog(false)
        },

        // drafts for collection prev and next come in without titles to avoid having to query the entire drafts
        // on the detail page, so add in the title here once we know it by loading the draft for display
        // this saves two network calls on every draft display

        addDisplayTitleToUrl(displayDraft) {
            let displayTitle = this.sanitizeUrlSegment(displayDraft.DisplayTitle)
            this.$router.replace({ params: { title: displayTitle } })
        },
        saveAsBlockWeave() {
            let userUnitWeaveIDsList = this.$store.state.userUnitWeaveIDs
            if (!userUnitWeaveIDsList.includes(this.draft.PatternID)) {
                userUnitWeaveIDsList.unshift(this.draft.PatternID)
                this.$store.commit('setUserUnitWeaveIDs', userUnitWeaveIDsList)
            }
            this.unitWeaveAddedMessageVisible = true
        },
        loadOrientation: function() {
            if (this.$store.getters.isSubscriber) {
                this.orientation = this.$store.state.authUserSettings.Orientation
            }
            return this.orientation
        },
        orientationChanged: function() {
            if (this.isAuthenticated) {
                // console.log('orientation: ' + this.orientation)
                if (this.authUser && this.authUserSettings) {
                    // console.log('current authUser orientation: ' + this.authUserSettings.Orientation)
                }
                else {
                    // console.log('no auth user or auth user settings for orientation')
                }
                if (this.orientation !== this.authUserSettings.Orientation) {
                    this.$store.commit('setPreferredTieupOrientation', this.orientation)
                    this.putUserSettings(this.authUser.UserID, this.authUserSettings, this.authUser.LoginToken)
                }
            }
        },

        loadColorEditor() {
            this.loadToolsDraftFromPatternId(this.$route.params.id, this.straightThreading, this.straightTreadling, this.pointThreading, this.pointTreadling, this.turned, false, this.authUser.UserID, this.authUser.LoginToken).then(() => {
                let colorEditorUrl = this.buildEditDraftUrl(false)
                this.$router.push(colorEditorUrl)
            })
        },

        loadDraftEditor() {
            this.loadToolsDraftFromPatternId(this.$route.params.id, this.straightThreading, this.straightTreadling, this.pointThreading, this.pointTreadling, this.turned, false, this.authUser.UserID, this.authUser.LoginToken).then(() => {
                let draftEditorUrl = this.buildEditDraftUrl(true)
                this.$router.push(draftEditorUrl)
            })
        },

        loadProfileEditor() {
            this.loadToolsDraftFromPatternId(this.$route.params.id, this.straightThreading, this.straightTreadling, this.pointThreading, this.pointTreadling, this.turned, false, this.authUser.UserID, this.authUser.LoginToken).then(() => {
                let profileEditorUrl = this.buildDraftProfileUrl()
                this.$router.push(profileEditorUrl)
            })
        },

        loadProfileEditorAsBlock() {
            this.loadToolsBlockProfileFromPatternId(this.$route.params.id, this.turned, this.authUser.UserID, this.authUser.LoginToken).then(() => {
                let profileEditorUrl = this.buildDraftProfileUrl()
                this.$router.push(profileEditorUrl)
            })
        },

        loadDraftRepeatsEditor() {
            this.loadToolsDraftFromPatternId(this.$route.params.id, this.straightThreading, this.straightTreadling, this.pointThreading, this.pointTreadling, this.turned, false, this.authUser.UserID, this.authUser.LoginToken).then(() => {
                let repeatsUrl = this.buildDraftRepeatsUrl()
                this.$router.push(repeatsUrl)
            })
        },

        loadDraftArranger() {
            this.loadToolsDraftFromPatternId(this.$route.params.id, this.straightThreading, this.straightTreadling, this.pointThreading, this.pointTreadling, this.turned, false, this.authUser.UserID, this.authUser.LoginToken).then(() => {
                let arrangerUrl = this.buildDraftArrangerUrl()
                this.$router.push(arrangerUrl)
            })
        },

        loadAmalgamationEditor() {
            this.loadToolsDraftFromPatternId(this.$route.params.id, this.straightThreading, this.straightTreadling, this.pointThreading, this.pointTreadling, this.turned, true, this.authUser.UserID, this.authUser.LoginToken).then(() => {
                let amalgamationUrl = this.buildDraftAmalgamationUrl()
                this.$router.push(amalgamationUrl)
            })
        }
    },

    watch: {
        '$route.params.id': function() {
            this.loadDraftData()
        },
        authUser: function() {
            this.loadOrientation()
            this.loadDraftData()
        },
        orientation: function() {
            this.orientationChanged()
        },
        turned: function() {
            this.flipThreadingOptionsUponTurned()
            this.loadMatchingThreadingPatternsCount()
            this.loadMatchingTieupPatternsCount()
            // this.loadProfileDraftUrl()
        },
        straightThreading: function() {
            if (this.straightThreading) {
                this.pointThreading = false
            }
            this.loadMatchingThreadingPatternsCount()
            this.loadMatchingTieupPatternsCount()
            // this.loadProfileDraftUrl()
        },
        straightTreadling: function() {
            if (this.straightTreadling) {
                this.pointTreadling = false
            }
            this.loadMatchingThreadingPatternsCount()
            this.loadMatchingTieupPatternsCount()
            // this.loadProfileDraftUrl()
        },
        pointThreading: function() {
            if (this.pointThreading) {
                this.straightThreading = false
            }
            this.loadMatchingThreadingPatternsCount()
            this.loadMatchingTieupPatternsCount()
            // this.loadProfileDraftUrl()
        },
        pointTreadling: function() {
            if (this.pointTreadling) {
                this.straightTreadling = false
            }
            this.loadMatchingThreadingPatternsCount()
            this.loadMatchingTieupPatternsCount()
            // this.loadProfileDraftUrl()
        }
    },

    computed: {
        isSubscriber: function() {
            return this.$store.getters.isSubscriber
        },

        isAuthenticated: function() {
            return this.$store.getters.isAuthenticated
        },

        authUser: function() {
            return this.$store.state.authUser
        },

        authUserSettings: function() {
            return this.$store.state.authUserSettings
        },

        draftImageUrlFunction: function() {
            return this.$store.state.draftImageUrlFunction
        },

        tagsButtonTitle: function() {
            if (this.allPatternTags.length===0) {
                return 'Tags'
            }
            else {
                return 'Tags (' + this.allPatternTags.length + ')'
            }
        },

        commentsButtonTitle: function() {
            if (this.allPatternComments.length===0) {
                return 'Comments'
            }
            else {
                return 'Comments (' + this.allPatternComments.length + ')'
            }
        },

        currentDraftImageUrl: function() {
            if (this.draft.PatternID > 0) {
                let draftImageUrl = ''
                if (!this.turned) {
                    draftImageUrl = this.draftImageUrlFunction(this.draft.PatternID, this.viewsize, this.orientation, this.turned, this.straightThreading, this.straightTreadling, this.pointThreading, this.pointTreadling, this.draft.IsStraightThreading, this.draft.IsStraightTreadling, this.draft.IsPointThreading, this.draft.IsPointTreadling, this.showAsLiftplan, this.draft.ImagesExist)
                }
                else {
                    draftImageUrl = this.draftImageUrlFunction(this.draft.PatternID, this.viewsize, this.orientation, this.turned, this.straightTreadling, this.straightThreading, this.pointTreadling, this.pointThreading, this.draft.IsStraightThreading, this.draft.IsStraightTreadling, this.draft.IsPointThreading, this.draft.IsPointTreadling, this.showAsLiftplan, this.draft.ImagesExist)
                }
                // console.log('Draft Image Url: ' + draftImageUrl)
                return draftImageUrl
            }
            else return ''
        },

        isMobileDevice: function() {
            return this.currentDeviceIsMobile()
        },

        pointThreadingOptionVisible() {
            // console.log('in pointThreadingOptionVisible: ' + JSON.stringify(this.draft))
            return (!this.turned && this.draftHasPointCompatibleThreading && !this.draft.IsPointThreading && this.draft.PointedShafts <= MAX_RETHREAD_COUNT) || (this.turned && this.draftHasPointCompatibleTreadling && !this.draft.IsPointTreadling && this.draft.PointedTreadles <= MAX_RETHREAD_COUNT)
        },

        pointTreadlingOptionVisible() {
            // console.log('in pointTreadlingOptionVisible: ' + JSON.stringify(this.draft))
            if (this.showAsLiftplan) {
                return false
            }
            return (!this.turned && this.draftHasPointCompatibleTreadling && !this.draft.IsPointTreadling && this.draft.PointedTreadles <= MAX_RETHREAD_COUNT) || (this.turned && this.draftHasPointCompatibleThreading && !this.draft.IsPointThreading && this.draft.PointedShafts <= MAX_RETHREAD_COUNT)
        },

        straightThreadingOptionVisible() {
            return (!this.turned && !this.draft.IsStraightThreading && this.draft.StraightenedShafts <= MAX_RETHREAD_COUNT) || (this.turned && !this.draft.IsStraightTreadling && this.draft.StraightenedTreadles <= MAX_RETHREAD_COUNT)
        },

        straightTreadlingOptionVisible() {
            if (this.showAsLiftplan) {
                return false
            }
            return (!this.turned && !this.draft.IsStraightTreadling && this.draft.StraightenedTreadles <= MAX_RETHREAD_COUNT) || (this.turned && !this.draft.IsStraightThreading && this.draft.StraightenedShafts <= MAX_RETHREAD_COUNT)
        },

        amalgamationDraftPageUrl() {
            if (this.turned) {
                return this.buildDraftAmalgamationUrl(this.draft, this.straightTreadling, this.straightThreading, this.pointTreadling, this.pointThreading)
            }
            else {
                return this.buildDraftAmalgamationUrl(this.draft, this.straightThreading, this.straightTreadling, this.pointThreading, this.pointTreadling)
            }
        },

        profileDraftingIsAvailable() {
            let profileNotTooLarge = this.profileDraftingAvailable(this.draft.WarpUnitThreads, this.draft.WeftUnitThreads)
            return this.draft && profileNotTooLarge
        },

        draftEditingIsAvailable() {
            return this.draftEditingAvailable(this.draft.WarpThreads, this.draft.WeftThreads)
        },

        amalgamationDraftingIsAvailable() {
            let currentShafts = this.draft.Shafts
            let currentTreadles = this.draft.Treadles
            if (this.pointThreading) {
                currentShafts = this.turned ? this.draft.PointedTreadles : this.draft.PointedShafts
            }
            if (this.pointTreadling) {
                currentTreadles = this.turned ? this.draft.PointedShafts : this.draft.PointedTreadles
            }
            if (this.straightThreading) {
                currentShafts = this.turned ? this.draft.StraightenedTreadles : this.draft.StraightenedShafts
            }
            if (this.straightTreadling) {
                currentTreadles = this.turned ? this.draft.StraightenedShafts : this.draft.StraightenedTreadles
            }
            return this.amalgamationDraftingAvailable(currentShafts, currentTreadles, this.draft.WarpUnitThreads, this.draft.WeftUnitThreads)
        },

        hasBlockProfile() {
            return this.draft && this.draft.IsBlockDraft // &&
            // NOTE: this logic lets the UI show all block drafts including those based on simple 2 x 2 divisions,
            // The tagging logic in TagAllBlockPatterns includes the remarked out lines below to only get those that are
            // complex blocks
            //   (this.draft.WarpUnitThreads / this.draft.DDBlockUnitCols > 2 ||
            //    this.draft.WeftUnitThreads / this.draft.DDBlockUnitRows > 2) &&
            //    this.draft.WarpColorsCount === 1 &&
            //    this.draft.WeftColorsCount === 1
        },

        useAsUnitWeaveAvailable() {
            // return this.draft.DDBlockUnitRows > 1 && this.draft.DDBlockUnitCols > 1 && this.draft.IsBlockDraft
            return false
        },

        unitWeavesCellPixelSize() {
            return this.viewsize < 4 ? 4 : this.viewsize
        }

    },
    created() {
        this.loadDraftData()
        this.loadOrientation()
    },
    unmounted() {
        window.removeEventListener('resize', determineOptimalDraftDisplaySizeFunction)
    }
}
</script>

<style scoped>
    .cover-image {
        max-width: 30%;
        vertical-align: top
    }
    .thick-border {
        border-width: 2px;
    }

    .btn:focus, .btn:active {
        outline: none !important;
        box-shadow: none;
    }

    input:focus, input:active {
        outline: none !important;
        box-shadow: none;
    }

    .padded-button {
        margin-right: 0.3rem;
        margin-bottom: 0.3rem;
        background-color: #f0f0f0;
    }

    .padded-button:hover {
        background-color: #dfdfdf;
    }

    .inputBox {
        width: 100%;
        padding-top: 0.2rem;
    }

    .newTagInput {
        width: 90%
    }

    .greylabel {
        background-color: rgb(249, 248, 245);
    }

    .bold-prompt {
        font-weight: bold;
    }

    .top-align {
        vertical-align: top
    }

    .comments-background-color {
        background-color: #f9f8f5;
    }

    .draft-details-table td {
        padding: 0.4rem; border: #f9f8f5 solid 1px
    }

    .draft-details-table tr {
        padding: 0px; border: none
    }

    .draft-details-table table {
        padding: 0px; border: none
    }

    .small-right-padded {
        padding-right: 0.4rem;
    }

    .tags-list {
        background-color: rgb(249, 248, 245);
        border-radius: 5px;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        margin-top: 0.8rem;
        margin-bottom: 0.5rem;
        border: 1px solid rgb(222, 226, 230);
    }
</style>
